import React, { Suspense } from 'react';
import CircularProgress from '../../../components_base/CircularProgress';

const CreateUserInvite = React.lazy(() => import('../components/CreateUserInvite'));
function CreateUserInviteView(props: any) {
  return (
    <Suspense fallback={<CircularProgress />}>
      <CreateUserInvite {...props} />
    </Suspense>
  );
}

export default CreateUserInviteView;
